import { Flex, Input, Select, Spacer, Stack, Text } from '@chakra-ui/react'
import { useContext } from 'react'
import { ScoresContext } from '../routes/ScoreListing'
import { capitalizedPath } from './Score'
import { ScoreWithRef } from '../types'
import { UseFormRegister, FieldErrors } from 'react-hook-form'

interface ScoreFormProps {
  score: ScoreWithRef
  register: UseFormRegister<any>
  errors: FieldErrors<any>
}

function ScoreForm({ score, register, errors }: ScoreFormProps) {
  const context = useContext(ScoresContext)

  if (!context) {
    return <div>Loading...</div>
  }

  const { songs } = context

  const songsOptions = Array.from(new Set(songs.map((song) => song.artist + '---' + song.song)))

  return (
    <>
      <Stack>
        <Flex shrink={0}>
          <Text>Accuracy: </Text>
          <Spacer />
          <Input
            w="80px"
            step="any"
            defaultValue={score.inputAccuracy || score.accuracy || ''}
            type="number"
            isInvalid={errors.accuracy ? true : false}
            {...register('accuracy', { required: true, min: 0, max: 100 })}
          />{' '}
        </Flex>
        <Flex shrink={0}>
          <Text>Longest Streak: </Text>
          <Spacer />
          <Input
            w="80px"
            defaultValue={score.inputLongestStreak || score.longestStreak || ''}
            type="number"
            isInvalid={errors.longestStreak ? true : false}
            {...register('longestStreak', { required: true })}
          />{' '}
        </Flex>
        <Flex shrink={0}>
          <Text>Absolute Score: </Text>
          <Spacer />
          <Input
            w="100px"
            defaultValue={score.inputAbsoluteScore || score.absoluteScore || ''}
            type="number"
            {...register('absoluteScore')}
          />{' '}
        </Flex>

        <Select
          placeholder="Select the path"
          defaultValue={score.inputPath || (score.path ? capitalizedPath(score.path) : '')}
          isInvalid={errors.path ? true : false}
          {...register('path', { required: true })}
        >
          <option value="Lead">Lead</option>
          <option value="Bonus Lead">Lead Bonus</option>
          <option value="Alternate Lead">Lead Alternate</option>
          <option value="Rhythm">Rhythm</option>
          <option value="Bonus Rhythm">Rhythm Bonus</option>
          <option value="Alternate Rhythm">Rhythm Alternate</option>
          <option value="Bass">Bass</option>
        </Select>

        <Select
          defaultValue={
            score.classifiedArtist && score.classifiedSong
              ? score.classifiedArtist + '---' + score.classifiedSong
              : ''
          }
          isInvalid={errors.artist_song ? true : false}
          placeholder="Select a song"
          {...register('artist_song', { required: true })}
        >
          {songsOptions.map((opt, ix) => (
            <option key={ix} value={opt}>
              {opt.replace('---', ' - ')}
            </option>
          ))}
        </Select>
      </Stack>
      {/* <Flex mt={10} color="red" flexDirection={"column"} alignItems={"flex-end"}>

      {errors.accuracy && <Text>Accuracy is required</Text>}
      {errors.longestStreak && <Text>Longest streak is required</Text>}

    </Flex> */}
    </>
  )
}

export default ScoreForm
